module.exports = __webpack_public_path__ + "media/images/gallery/constellations/canes_venatici/cvn_vis-9f4e41ca2c8cb360fb20b84f286c77f1.jpg";